// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 795) return "static/chunks/795.1a1d7c410b8967ac.js";
	if (chunkId === 563) return "static/chunks/563.a317e653779a1dea.js";
	if (chunkId === 162) return "static/chunks/162.18aafb8fc226f453.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"43":"85350f689832ff17","127":"8081b960486149de","495":"947ee4259496c547","992":"9766b3d9562d437f"}[chunkId] + ".js";
};